import React, { createContext, useState, useEffect } from 'react';
import { messages, SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from '../locales';

import { debugLog, debugWarn, debugError } from '../../utils/debug.js';
export const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    // 동기적으로 초기 언어 설정
    try {
      const savedLanguage = localStorage.getItem('smileprint_language');
      if (savedLanguage && SUPPORTED_LANGUAGES.includes(savedLanguage)) {
        debugLog('[i18n] Loaded language from localStorage:', savedLanguage);
        return savedLanguage;
      }

      const browserLang = navigator.language.split('-')[0];
      debugLog('[i18n] Browser language:', browserLang);

      if (SUPPORTED_LANGUAGES.includes(browserLang)) {
        localStorage.setItem('smileprint_language', browserLang);
        debugLog('[i18n] Set language from browser:', browserLang);
        return browserLang;
      }

      localStorage.setItem('smileprint_language', DEFAULT_LANGUAGE);
      debugLog('[i18n] Using default language:', DEFAULT_LANGUAGE);
      return DEFAULT_LANGUAGE;
    } catch (err) {
      debugError('[i18n] Error initializing language:', err);
      return DEFAULT_LANGUAGE;
    }
  });

  // 로딩 상태는 삭제 - 동기적으로 처리되므로 필요 없음

  const changeLanguage = (newLanguage) => {
    if (SUPPORTED_LANGUAGES.includes(newLanguage)) {
      setLanguage(newLanguage);
      localStorage.setItem('smileprint_language', newLanguage);
      debugLog('[i18n] Language changed to:', newLanguage);
    } else {
      debugWarn('[i18n] Unsupported language:', newLanguage);
    }
  };

  // 언어가 설정되면 바로 렌더링 (로딩 화면 없음)
  return (
    <LanguageContext.Provider
      value={{
        language,
        changeLanguage,
        t: messages[language] || messages[DEFAULT_LANGUAGE],
        supportedLanguages: SUPPORTED_LANGUAGES
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
}
